// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --white: #ffffff;
  --bgColor: #f7f7f7;
  --txtColor: #030229;
  --logoPrimary: #0d77b1;
  --logoSecondary: #01b9ef;
  --hoverColor: #010120;
  --linkColor: #a7a7a7;
  --shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.025);
}

body {
  margin: 0;
  font-family: Nunito, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

.icon svg {
  /* fill: red; */
}

.btn-group {
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
}

header {
  background-color: var(--white);
  box-shadow: var(--shadow);
  padding: 1.5rem;
  border-radius: 0.75rem;
}

.wrapper > header {
  box-shadow: none !important;
}

.list-item {
  padding: 0.5rem !important;
}

main {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  background-color: var(--bgColor);

  header {
    margin: 2rem;
  }

  h1 {
    font-family: Nunito, sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    text-align: left;
    /* margin: 2.25rem; */
  }

  section {
    border-radius: 0.75rem;
    margin: 0 2rem;

    .wrappper {
      background-color: var(--white);
      box-shadow: var(--shadow);
      padding: 1.5rem;

      h2 {
        font-size: 1.125rem;
        font-weight: 700;
      }

      header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 1.25rem;
      }
    }

    header {
      padding: 0;
    }
  }
}

aside.sidebar {
  width: 14rem;
  height: 100vh;
  background-color: var(--white);
  position: relative;
  display: block;
  box-shadow: var(--shadow);
  transition: all 0.3s;

  header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    box-shadow: none;

    a {
      &:hover {
        color: var(--hoverColor);
      }
    }

    .project-title {
      display: flex;
      align-items: center;
      gap: 1rem;

      .project-logo {
        width: 3.5rem;
        height: 3.5rem;
      }

      .project-name {
        font-family: Nunito, sans-serif;
        display: inline-block;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        margin-top: 8px;
        height: 36px;
        color: var(--logoPrimary);
      }
    }
  }

  nav {
    margin-top: 0.25rem;
    padding-right: 1rem;

    a {
      display: flex;
      justify-content: space-between;
      gap: 1.25rem;
      border-radius: 0;
      align-items: center;
      font-size: 1rem;
      font-weight: 500;
      color: var(--linkColor);
      padding: 0 1.75rem;
      opacity: 1;
      transition: opacity 0.5s;

      &:where(:hover, .active) {
        color: var(--logoPrimary);
        /* background-image: linear-gradient(
          to right,
          var(--logoSecondary) -40%,
          var(--white) 100%
        ); */
      }

      span {
        width: 2.5rem;
        height: 2.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;

        svg {
          width: 1.5rem;
          height: 1.5rem;
        }
      }

      .title {
        display: block;
        width: 100%;
        line-height: 2.5rem;
      }
    }
  }

  footer {
    width: 100%;
    padding: 0.75rem;
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;

    img {
      width: 2.5rem;
      height: 2.5rem;
    }

    .current-user {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      /* visibility: hidden; */
    }

    .info {
      .name {
        font-size: 0.75rem;
        font-weight: 500;
        text-align: left;
      }

      .role {
        font-size: 0.75rem;
        font-weight: 400;
        text-align: left;
      }
    }
  }

  .toggle-switch {
    font-size: 1rem;
    font-weight: 600;
    color: var(--linkColor);
    justify-content: flex-end;
    transform: rotate(180deg);
    transition: all 0.3s;
  }

  #toggle-chk {
    display: none;
  }

  &:has(input[name="toggle-chk"]:checked) {
    width: 5rem;

    nav a > span:last-child {
      opacity: 0;
    }

    header {
      .project-logo {
        width: 3rem;
        height: 3rem;
      }

      .project-name {
        display: none;
      }
    }

    footer {
      flex-direction: column;

      .current-user {
        gap: 0;
      }

      .info,
      .login-btn {
        width: 0;
        opacity: 0;
      }

      .toggle-switch {
        justify-content: center;
        transform: rotate(0deg);
      }
    }
  }
}

.infos {
  display: grid;

  .info {
    display: flex;
    gap: 1rem;
    border-radius: 0.75rem;
    padding: 1.25rem 2rem;
    background-color: var(--white);
    box-shadow: var(--shadow);

    .icon-wrapper {
      width: 4rem;
      height: 4rem;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      .icon {
        font-size: 1.875rem;
        color: var(--logoPrimary);
      }
    }

    .content {
      text-align: left;
      color: var(--txtColor);

      .value {
        font-weight: 700;
        font-size: 1.5rem;
      }

      .title {
        font-size: 1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 10rem;
      }
    }
  }
}

.lists {
  margin: 2rem;

  .wrapper {
    background-color: var(--white);
    box-shadow: var(--shadow);
    border-radius: 0.75rem;
    padding: 1.5rem;

    header {
      display: flex;
      justify-content: space-between;
      padding: 0;
      margin-left: 0;
      h2 {
        font-weight: 700;
        font-size: 1.125rem;
      }
    }
  }
}

.scenario-single {
  .container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    section:first-child {
      width: 100%;
      padding: 1.5rem;
      display: flex;
      gap: 2rem;
      margin: 0;

      .wrapper {
        padding: 1.5rem;
        border-radius: 0.75rem;
        box-shadow: var(--shadow);
        width: 100%;
        background-color: var(--white);

        header {
          display: flex;
          justify-content: space-between;
          margin-left: 0 !important;
        }

        h2 {
          font-size: 1.125rem;
          font-weight: 700;
        }

        .iframe {
          width: 100%;
          height: 400px;
        }
      }
      .table-row td {
        padding: 0.75rem 0;
      }
    }

    section:last-child {
      width: 100%;
      padding: 1.5rem;
      display: flex;
      gap: 2rem;
      margin: 0;
      /* height: calc(100vh - 155px); */
      .wrapper {
        padding: 1.5rem;
        border-radius: 0.75rem;
        box-shadow: var(--shadow);
        width: 100%;
        background-color: var(--white);

        header {
          margin-left: 0;
          display: flex;
          justify-content: space-between;
        }
      }

      h2 {
        font-size: 1.125rem;
        font-weight: 700;
      }

      span {
        font-size: 1.5rem;
      }
    }

    .input-group {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 1rem;
    }
  }
}

section.about-us {
  background-color: var(--white);
  box-shadow: var(--shadow);
  padding: 1.5rem;
  margin: 2rem;

  .info {
    font-size: 90%;

    .row {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
      margin-bottom: 1rem;

      span:first-child {
        font-weight: 700;
      }

      ul {
        list-style: none;
        li {
          margin-bottom: 0.5rem;
          margin-left: 0.5rem;
        }
      }
    }
  }

  .summary {
    p {
      margin-bottom: 1rem;
      line-height: 125%;
    }
  }
}

section.charts {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  .chart {
    width: 50%;
    box-shadow: var(--shadow);
    border-radius: 0.75rem;

    .wrapper {
      background-color: var(--white);
      border-radius: 0.75rem;
      padding: 1.5rem;

      header {
        display: flex;
        justify-content: space-between;

        h2 {
          font-weight: 700;
          font-size: 1.125rem;
          padding-left: 0;
        }
      }
    }
  }
}

section.scenarios {
  .wrapper {
    background-color: var(--white);
    box-shadow: var(--shadow);
    border-radius: 0.75rem;
    padding: 1.5rem;
  }

  .list-item {
    padding: 0.5rem;
  }
}

section.users {
  #scrollableDiv {
    background-color: var(--white);
    border-radius: 0.75rem;
    padding: 1.5rem;
  }
}

section.user {
  height: 100%;

  .wrapper {
    /* height: calc(100% - 160px); */
    display: flex;
    gap: 2rem;

    .card {
      width: 50%;
      height: 100%;
      background-color: var(--white);
      padding: 1.5rem;
      border-radius: 0.75rem;
      box-shadow: var(--shadow);

      .info {
        display: flex;
        gap: 1rem;
        align-items: center;
        padding-bottom: 1rem;
        border-block-end: 1px solid rgba(5, 5, 5, 0.06);

        .profile-photo {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          box-shadow: var(--shadow);
        }

        .user-icon {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          box-shadow: var(--shadow);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 3rem;
        }
      }

      .stats {
        margin-top: 1rem;
        font-size: 1.125rem;
        font-weight: 700;
        width: 100%;

        .wrapper-chart {
          width: 100% !important;
          header {
            margin-left: 1rem;
            h2 {
              font-size: 1.25rem;
            }
          }
        }
      }
    }

    .list {
      width: 50%;
      height: 100%;
      background-color: var(--white);
      padding: 1.5rem;
      border-radius: 0.75rem;
      box-shadow: var(--shadow);
      overflow-y: scroll;
    }
  }
}

section.partners {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 2rem;

  .ant-card {
    padding: 2rem 1rem;

    .partner-logo {
      height: 80px;
      object-fit: contain;
    }
  }
}

section.partner {
  height: 100%;

  header {
    margin: 2rem 0 !important;
    padding: 1rem;

    .logo {
      height: 4rem;
    }
  }
  .wrapper {
    height: calc(100% - 260px);
    display: flex;
    gap: 2rem;

    .card {
      background-color: var(--white);
      padding: 1.5rem;
      border-radius: 0.75rem;
      box-shadow: var(--shadow);

      .title {
        display: flex;
        gap: 1rem;
        align-items: center;
        justify-content: flex-start;
        padding-bottom: 1rem;
        border-block-end: 1px solid rgba(5, 5, 5, 0.06);
        margin-bottom: 2rem;
        h1 {
          span {
            color: var(--linkColor);
            font-size: 80%;
          }
        }
      }

      .info {
        border-block-end: 1px solid rgba(5, 5, 5, 0.06);
        padding-bottom: 1rem;
        margin-bottom: 2rem;
      }

      .descriptions {
        margin: 2rem 0 1rem;
        line-height: 1.25rem;
        p {
          margin-bottom: 1rem;
        }
      }

      .stats {
        margin-top: 1rem;
        font-size: 1.125rem;
        font-weight: 700;

        .wrapper-chart {
          header {
            margin-left: 1rem;
            h2 {
              font-size: 1.25rem;
            }
          }
        }
      }
    }
  }
}

.msg-form {
  display: flex;
  gap: 0.25rem;
}

.msg-input {
  border: none;
  outline: none;
  border: 1px solid #a7a7a7;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
}

.msg-btn {
  border: none;
  outline: none;
  border: 1px solid #a7a7a7;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.3s;
}

.msg-btn:hover {
  background-color: #a7a7a7;
  color: #fff;
}

.msg-result {
  color: #5cb85c;
  font-size: 13px;
  padding-left: 0.5rem;
}

.msg-result[data-value=""] {
  display: none;
}

.cards {
  display: flex;
  flex-wrap: wrap;
  gap: 4rem;
}

.card {
  width: calc((100% - 8rem) / 3);
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 5px 25px 0px rgba(8, 5, 33, 0.08);
  padding: 30px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  color: #222;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
}

.card-desc {
  text-transform: capitalize !important;
}

.icon {
  transition: all 0.3s ease;
  font-size: 32px;
  color: #ccc !important;
}

.card:hover {
  color: var(--logoSecondary);
}

.card:hover .icon {
  transform: translateY(-0.5rem);
}

.flex-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-start {
  align-items: flex-start;
}

.half {
  width: 50%;
  background-color: var(--white);
}

.one-third {
  width: 33.33%;
  background-color: var(--white);
  padding: 1rem;
}

.two-third {
  width: 66.66%;
  background-color: var(--white);
  padding: 1rem;
}

.entry {
  width: 500px;
  padding: 1rem;
  background-color: var(--white);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.entry label {
  font-size: 14px;
  width: 40%;
}

.input {
  width: calc(100% - 1rem) !important;
  margin: 1rem;
  margin-left: 1rem;
}

.label {
  margin-left: 1rem;
}

.login-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.modal-title {
  margin-bottom: 1rem;
}

.register-link {
  display: inline-block;
  margin-top: 0.5rem;
}

.login-wrapper {
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
}

.formItem {
  margin-bottom: 1.5rem;
}

.ant-form-item-explain-error {
  margin-bottom: 1rem;
}

.error {
  color: #ef5350;
}

header p,
header div p {
  color: #777;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gCAAgC;;EAEhC;IACE,YAAY;EACd;;EAEA;IACE,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,cAAc;;IAEd;MACE,8BAA8B;MAC9B,yBAAyB;MACzB,eAAe;;MAEf;QACE,mBAAmB;QACnB,gBAAgB;MAClB;;MAEA;QACE,aAAa;QACb,8BAA8B;QAC9B,sBAAsB;MACxB;IACF;;IAEA;MACE,UAAU;IACZ;EACF;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;;EAEpB;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;;IAEhB;MACE;QACE,wBAAwB;MAC1B;IACF;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;;MAET;QACE,aAAa;QACb,cAAc;MAChB;;MAEA;QACE,+BAA+B;QAC/B,qBAAqB;QACrB,kBAAkB;QAClB,eAAe;QACf,iBAAiB;QACjB,eAAe;QACf,YAAY;QACZ,yBAAyB;MAC3B;IACF;EACF;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;;IAEnB;MACE,aAAa;MACb,8BAA8B;MAC9B,YAAY;MACZ,gBAAgB;MAChB,mBAAmB;MACnB,eAAe;MACf,gBAAgB;MAChB,uBAAuB;MACvB,kBAAkB;MAClB,UAAU;MACV,wBAAwB;;MAExB;QACE,yBAAyB;QACzB;;;;YAII;MACN;;MAEA;QACE,aAAa;QACb,cAAc;QACd,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,oBAAoB;;QAEpB;UACE,aAAa;UACb,cAAc;QAChB;MACF;;MAEA;QACE,cAAc;QACd,WAAW;QACX,mBAAmB;MACrB;IACF;EACF;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;;IAEZ;MACE,aAAa;MACb,cAAc;IAChB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ,wBAAwB;IAC1B;;IAEA;MACE;QACE,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;MAClB;;MAEA;QACE,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;MAClB;IACF;EACF;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;;IAEX;MACE,UAAU;IACZ;;IAEA;MACE;QACE,WAAW;QACX,YAAY;MACd;;MAEA;QACE,aAAa;MACf;IACF;;IAEA;MACE,sBAAsB;;MAEtB;QACE,MAAM;MACR;;MAEA;;QAEE,QAAQ;QACR,UAAU;MACZ;;MAEA;QACE,uBAAuB;QACvB,uBAAuB;MACzB;IACF;EACF;AACF;;AAEA;EACE,aAAa;;EAEb;IACE,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,qBAAqB;IACrB,8BAA8B;IAC9B,yBAAyB;;IAEzB;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;;MAEvB;QACE,mBAAmB;QACnB,yBAAyB;MAC3B;IACF;;IAEA;MACE,gBAAgB;MAChB,sBAAsB;;MAEtB;QACE,gBAAgB;QAChB,iBAAiB;MACnB;;MAEA;QACE,eAAe;QACf,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;QACnB,YAAY;MACd;IACF;EACF;AACF;;AAEA;EACE,YAAY;;EAEZ;IACE,8BAA8B;IAC9B,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;;IAEf;MACE,aAAa;MACb,8BAA8B;MAC9B,UAAU;MACV,cAAc;MACd;QACE,gBAAgB;QAChB,mBAAmB;MACrB;IACF;EACF;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;;IAEvB;MACE,WAAW;MACX,eAAe;MACf,aAAa;MACb,SAAS;MACT,SAAS;;MAET;QACE,eAAe;QACf,sBAAsB;QACtB,yBAAyB;QACzB,WAAW;QACX,8BAA8B;;QAE9B;UACE,aAAa;UACb,8BAA8B;UAC9B,yBAAyB;QAC3B;;QAEA;UACE,mBAAmB;UACnB,gBAAgB;QAClB;;QAEA;UACE,WAAW;UACX,aAAa;QACf;MACF;MACA;QACE,kBAAkB;MACpB;IACF;;IAEA;MACE,WAAW;MACX,eAAe;MACf,aAAa;MACb,SAAS;MACT,SAAS;MACT,iCAAiC;MACjC;QACE,eAAe;QACf,sBAAsB;QACtB,yBAAyB;QACzB,WAAW;QACX,8BAA8B;;QAE9B;UACE,cAAc;UACd,aAAa;UACb,8BAA8B;QAChC;MACF;;MAEA;QACE,mBAAmB;QACnB,gBAAgB;MAClB;;MAEA;QACE,iBAAiB;MACnB;IACF;;IAEA;MACE,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,WAAW;MACX,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,YAAY;;EAEZ;IACE,cAAc;;IAEd;MACE,aAAa;MACb,sBAAsB;MACtB,YAAY;MACZ,mBAAmB;;MAEnB;QACE,gBAAgB;MAClB;;MAEA;QACE,gBAAgB;QAChB;UACE,qBAAqB;UACrB,mBAAmB;QACrB;MACF;IACF;EACF;;EAEA;IACE;MACE,mBAAmB;MACnB,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;;EAET;IACE,UAAU;IACV,yBAAyB;IACzB,sBAAsB;;IAEtB;MACE,8BAA8B;MAC9B,sBAAsB;MACtB,eAAe;;MAEf;QACE,aAAa;QACb,8BAA8B;;QAE9B;UACE,gBAAgB;UAChB,mBAAmB;UACnB,eAAe;QACjB;MACF;IACF;EACF;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,sBAAsB;IACtB,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;;EAEZ;IACE,gCAAgC;IAChC,aAAa;IACb,SAAS;;IAET;MACE,UAAU;MACV,YAAY;MACZ,8BAA8B;MAC9B,eAAe;MACf,sBAAsB;MACtB,yBAAyB;;MAEzB;QACE,aAAa;QACb,SAAS;QACT,mBAAmB;QACnB,oBAAoB;QACpB,+CAA+C;;QAE/C;UACE,WAAW;UACX,YAAY;UACZ,kBAAkB;UAClB,yBAAyB;QAC3B;;QAEA;UACE,WAAW;UACX,YAAY;UACZ,kBAAkB;UAClB,yBAAyB;UACzB,aAAa;UACb,mBAAmB;UACnB,uBAAuB;UACvB,eAAe;QACjB;MACF;;MAEA;QACE,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;QAChB,WAAW;;QAEX;UACE,sBAAsB;UACtB;YACE,iBAAiB;YACjB;cACE,kBAAkB;YACpB;UACF;QACF;MACF;IACF;;IAEA;MACE,UAAU;MACV,YAAY;MACZ,8BAA8B;MAC9B,eAAe;MACf,sBAAsB;MACtB,yBAAyB;MACzB,kBAAkB;IACpB;EACF;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,YAAY;;EAEZ;IACE,kBAAkB;;IAElB;MACE,YAAY;MACZ,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE,YAAY;;EAEZ;IACE,yBAAyB;IACzB,aAAa;;IAEb;MACE,YAAY;IACd;EACF;EACA;IACE,0BAA0B;IAC1B,aAAa;IACb,SAAS;;IAET;MACE,8BAA8B;MAC9B,eAAe;MACf,sBAAsB;MACtB,yBAAyB;;MAEzB;QACE,aAAa;QACb,SAAS;QACT,mBAAmB;QACnB,2BAA2B;QAC3B,oBAAoB;QACpB,+CAA+C;QAC/C,mBAAmB;QACnB;UACE;YACE,uBAAuB;YACvB,cAAc;UAChB;QACF;MACF;;MAEA;QACE,+CAA+C;QAC/C,oBAAoB;QACpB,mBAAmB;MACrB;;MAEA;QACE,mBAAmB;QACnB,oBAAoB;QACpB;UACE,mBAAmB;QACrB;MACF;;MAEA;QACE,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;;QAEhB;UACE;YACE,iBAAiB;YACjB;cACE,kBAAkB;YACpB;UACF;QACF;MACF;IACF;EACF;AACF;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iDAAiD;EACjD,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb","sourcesContent":[":root {\n  --white: #ffffff;\n  --bgColor: #f7f7f7;\n  --txtColor: #030229;\n  --logoPrimary: #0d77b1;\n  --logoSecondary: #01b9ef;\n  --hoverColor: #010120;\n  --linkColor: #a7a7a7;\n  --shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.025);\n}\n\nbody {\n  margin: 0;\n  font-family: Nunito, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n.icon svg {\n  /* fill: red; */\n}\n\n.btn-group {\n  display: flex;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\nheader {\n  background-color: var(--white);\n  box-shadow: var(--shadow);\n  padding: 1.5rem;\n  border-radius: 0.75rem;\n}\n\n.wrapper > header {\n  box-shadow: none !important;\n}\n\n.list-item {\n  padding: 0.5rem !important;\n}\n\nmain {\n  width: 100%;\n  height: 100vh;\n  overflow-y: scroll;\n  background-color: var(--bgColor);\n\n  header {\n    margin: 2rem;\n  }\n\n  h1 {\n    font-family: Nunito, sans-serif;\n    font-size: 1.5rem;\n    font-weight: 700;\n    text-align: left;\n    /* margin: 2.25rem; */\n  }\n\n  section {\n    border-radius: 0.75rem;\n    margin: 0 2rem;\n\n    .wrappper {\n      background-color: var(--white);\n      box-shadow: var(--shadow);\n      padding: 1.5rem;\n\n      h2 {\n        font-size: 1.125rem;\n        font-weight: 700;\n      }\n\n      header {\n        display: flex;\n        justify-content: space-between;\n        margin-bottom: 1.25rem;\n      }\n    }\n\n    header {\n      padding: 0;\n    }\n  }\n}\n\naside.sidebar {\n  width: 14rem;\n  height: 100vh;\n  background-color: var(--white);\n  position: relative;\n  display: block;\n  box-shadow: var(--shadow);\n  transition: all 0.3s;\n\n  header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 16px;\n    font-size: 14px;\n    font-weight: 500;\n    text-align: center;\n    box-shadow: none;\n\n    a {\n      &:hover {\n        color: var(--hoverColor);\n      }\n    }\n\n    .project-title {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n\n      .project-logo {\n        width: 3.5rem;\n        height: 3.5rem;\n      }\n\n      .project-name {\n        font-family: Nunito, sans-serif;\n        display: inline-block;\n        text-align: center;\n        font-size: 24px;\n        font-weight: bold;\n        margin-top: 8px;\n        height: 36px;\n        color: var(--logoPrimary);\n      }\n    }\n  }\n\n  nav {\n    margin-top: 0.25rem;\n    padding-right: 1rem;\n\n    a {\n      display: flex;\n      justify-content: space-between;\n      gap: 1.25rem;\n      border-radius: 0;\n      align-items: center;\n      font-size: 1rem;\n      font-weight: 500;\n      color: var(--linkColor);\n      padding: 0 1.75rem;\n      opacity: 1;\n      transition: opacity 0.5s;\n\n      &:where(:hover, .active) {\n        color: var(--logoPrimary);\n        /* background-image: linear-gradient(\n          to right,\n          var(--logoSecondary) -40%,\n          var(--white) 100%\n        ); */\n      }\n\n      span {\n        width: 2.5rem;\n        height: 2.5rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: all 0.3s;\n\n        svg {\n          width: 1.5rem;\n          height: 1.5rem;\n        }\n      }\n\n      .title {\n        display: block;\n        width: 100%;\n        line-height: 2.5rem;\n      }\n    }\n  }\n\n  footer {\n    width: 100%;\n    padding: 0.75rem;\n    position: absolute;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n\n    img {\n      width: 2.5rem;\n      height: 2.5rem;\n    }\n\n    .current-user {\n      display: flex;\n      align-items: center;\n      gap: 0.75rem;\n      /* visibility: hidden; */\n    }\n\n    .info {\n      .name {\n        font-size: 0.75rem;\n        font-weight: 500;\n        text-align: left;\n      }\n\n      .role {\n        font-size: 0.75rem;\n        font-weight: 400;\n        text-align: left;\n      }\n    }\n  }\n\n  .toggle-switch {\n    font-size: 1rem;\n    font-weight: 600;\n    color: var(--linkColor);\n    justify-content: flex-end;\n    transform: rotate(180deg);\n    transition: all 0.3s;\n  }\n\n  #toggle-chk {\n    display: none;\n  }\n\n  &:has(input[name=\"toggle-chk\"]:checked) {\n    width: 5rem;\n\n    nav a > span:last-child {\n      opacity: 0;\n    }\n\n    header {\n      .project-logo {\n        width: 3rem;\n        height: 3rem;\n      }\n\n      .project-name {\n        display: none;\n      }\n    }\n\n    footer {\n      flex-direction: column;\n\n      .current-user {\n        gap: 0;\n      }\n\n      .info,\n      .login-btn {\n        width: 0;\n        opacity: 0;\n      }\n\n      .toggle-switch {\n        justify-content: center;\n        transform: rotate(0deg);\n      }\n    }\n  }\n}\n\n.infos {\n  display: grid;\n\n  .info {\n    display: flex;\n    gap: 1rem;\n    border-radius: 0.75rem;\n    padding: 1.25rem 2rem;\n    background-color: var(--white);\n    box-shadow: var(--shadow);\n\n    .icon-wrapper {\n      width: 4rem;\n      height: 4rem;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      .icon {\n        font-size: 1.875rem;\n        color: var(--logoPrimary);\n      }\n    }\n\n    .content {\n      text-align: left;\n      color: var(--txtColor);\n\n      .value {\n        font-weight: 700;\n        font-size: 1.5rem;\n      }\n\n      .title {\n        font-size: 1rem;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        width: 10rem;\n      }\n    }\n  }\n}\n\n.lists {\n  margin: 2rem;\n\n  .wrapper {\n    background-color: var(--white);\n    box-shadow: var(--shadow);\n    border-radius: 0.75rem;\n    padding: 1.5rem;\n\n    header {\n      display: flex;\n      justify-content: space-between;\n      padding: 0;\n      margin-left: 0;\n      h2 {\n        font-weight: 700;\n        font-size: 1.125rem;\n      }\n    }\n  }\n}\n\n.scenario-single {\n  .container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-start;\n\n    section:first-child {\n      width: 100%;\n      padding: 1.5rem;\n      display: flex;\n      gap: 2rem;\n      margin: 0;\n\n      .wrapper {\n        padding: 1.5rem;\n        border-radius: 0.75rem;\n        box-shadow: var(--shadow);\n        width: 100%;\n        background-color: var(--white);\n\n        header {\n          display: flex;\n          justify-content: space-between;\n          margin-left: 0 !important;\n        }\n\n        h2 {\n          font-size: 1.125rem;\n          font-weight: 700;\n        }\n\n        .iframe {\n          width: 100%;\n          height: 400px;\n        }\n      }\n      .table-row td {\n        padding: 0.75rem 0;\n      }\n    }\n\n    section:last-child {\n      width: 100%;\n      padding: 1.5rem;\n      display: flex;\n      gap: 2rem;\n      margin: 0;\n      /* height: calc(100vh - 155px); */\n      .wrapper {\n        padding: 1.5rem;\n        border-radius: 0.75rem;\n        box-shadow: var(--shadow);\n        width: 100%;\n        background-color: var(--white);\n\n        header {\n          margin-left: 0;\n          display: flex;\n          justify-content: space-between;\n        }\n      }\n\n      h2 {\n        font-size: 1.125rem;\n        font-weight: 700;\n      }\n\n      span {\n        font-size: 1.5rem;\n      }\n    }\n\n    .input-group {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 0.5rem;\n      margin-bottom: 1rem;\n    }\n  }\n}\n\nsection.about-us {\n  background-color: var(--white);\n  box-shadow: var(--shadow);\n  padding: 1.5rem;\n  margin: 2rem;\n\n  .info {\n    font-size: 90%;\n\n    .row {\n      display: flex;\n      flex-direction: column;\n      gap: 0.25rem;\n      margin-bottom: 1rem;\n\n      span:first-child {\n        font-weight: 700;\n      }\n\n      ul {\n        list-style: none;\n        li {\n          margin-bottom: 0.5rem;\n          margin-left: 0.5rem;\n        }\n      }\n    }\n  }\n\n  .summary {\n    p {\n      margin-bottom: 1rem;\n      line-height: 125%;\n    }\n  }\n}\n\nsection.charts {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n\n  .chart {\n    width: 50%;\n    box-shadow: var(--shadow);\n    border-radius: 0.75rem;\n\n    .wrapper {\n      background-color: var(--white);\n      border-radius: 0.75rem;\n      padding: 1.5rem;\n\n      header {\n        display: flex;\n        justify-content: space-between;\n\n        h2 {\n          font-weight: 700;\n          font-size: 1.125rem;\n          padding-left: 0;\n        }\n      }\n    }\n  }\n}\n\nsection.scenarios {\n  .wrapper {\n    background-color: var(--white);\n    box-shadow: var(--shadow);\n    border-radius: 0.75rem;\n    padding: 1.5rem;\n  }\n\n  .list-item {\n    padding: 0.5rem;\n  }\n}\n\nsection.users {\n  #scrollableDiv {\n    background-color: var(--white);\n    border-radius: 0.75rem;\n    padding: 1.5rem;\n  }\n}\n\nsection.user {\n  height: 100%;\n\n  .wrapper {\n    /* height: calc(100% - 160px); */\n    display: flex;\n    gap: 2rem;\n\n    .card {\n      width: 50%;\n      height: 100%;\n      background-color: var(--white);\n      padding: 1.5rem;\n      border-radius: 0.75rem;\n      box-shadow: var(--shadow);\n\n      .info {\n        display: flex;\n        gap: 1rem;\n        align-items: center;\n        padding-bottom: 1rem;\n        border-block-end: 1px solid rgba(5, 5, 5, 0.06);\n\n        .profile-photo {\n          width: 64px;\n          height: 64px;\n          border-radius: 50%;\n          box-shadow: var(--shadow);\n        }\n\n        .user-icon {\n          width: 64px;\n          height: 64px;\n          border-radius: 50%;\n          box-shadow: var(--shadow);\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          font-size: 3rem;\n        }\n      }\n\n      .stats {\n        margin-top: 1rem;\n        font-size: 1.125rem;\n        font-weight: 700;\n        width: 100%;\n\n        .wrapper-chart {\n          width: 100% !important;\n          header {\n            margin-left: 1rem;\n            h2 {\n              font-size: 1.25rem;\n            }\n          }\n        }\n      }\n    }\n\n    .list {\n      width: 50%;\n      height: 100%;\n      background-color: var(--white);\n      padding: 1.5rem;\n      border-radius: 0.75rem;\n      box-shadow: var(--shadow);\n      overflow-y: scroll;\n    }\n  }\n}\n\nsection.partners {\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin: 2rem;\n\n  .ant-card {\n    padding: 2rem 1rem;\n\n    .partner-logo {\n      height: 80px;\n      object-fit: contain;\n    }\n  }\n}\n\nsection.partner {\n  height: 100%;\n\n  header {\n    margin: 2rem 0 !important;\n    padding: 1rem;\n\n    .logo {\n      height: 4rem;\n    }\n  }\n  .wrapper {\n    height: calc(100% - 260px);\n    display: flex;\n    gap: 2rem;\n\n    .card {\n      background-color: var(--white);\n      padding: 1.5rem;\n      border-radius: 0.75rem;\n      box-shadow: var(--shadow);\n\n      .title {\n        display: flex;\n        gap: 1rem;\n        align-items: center;\n        justify-content: flex-start;\n        padding-bottom: 1rem;\n        border-block-end: 1px solid rgba(5, 5, 5, 0.06);\n        margin-bottom: 2rem;\n        h1 {\n          span {\n            color: var(--linkColor);\n            font-size: 80%;\n          }\n        }\n      }\n\n      .info {\n        border-block-end: 1px solid rgba(5, 5, 5, 0.06);\n        padding-bottom: 1rem;\n        margin-bottom: 2rem;\n      }\n\n      .descriptions {\n        margin: 2rem 0 1rem;\n        line-height: 1.25rem;\n        p {\n          margin-bottom: 1rem;\n        }\n      }\n\n      .stats {\n        margin-top: 1rem;\n        font-size: 1.125rem;\n        font-weight: 700;\n\n        .wrapper-chart {\n          header {\n            margin-left: 1rem;\n            h2 {\n              font-size: 1.25rem;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.msg-form {\n  display: flex;\n  gap: 0.25rem;\n}\n\n.msg-input {\n  border: none;\n  outline: none;\n  border: 1px solid #a7a7a7;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n}\n\n.msg-btn {\n  border: none;\n  outline: none;\n  border: 1px solid #a7a7a7;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.msg-btn:hover {\n  background-color: #a7a7a7;\n  color: #fff;\n}\n\n.msg-result {\n  color: #5cb85c;\n  font-size: 13px;\n  padding-left: 0.5rem;\n}\n\n.msg-result[data-value=\"\"] {\n  display: none;\n}\n\n.cards {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4rem;\n}\n\n.card {\n  width: calc((100% - 8rem) / 3);\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 0px 5px 25px 0px rgba(8, 5, 33, 0.08);\n  padding: 30px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  color: #222;\n}\n\n.card-title {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.card-desc {\n  text-transform: capitalize !important;\n}\n\n.icon {\n  transition: all 0.3s ease;\n  font-size: 32px;\n  color: #ccc !important;\n}\n\n.card:hover {\n  color: var(--logoSecondary);\n}\n\n.card:hover .icon {\n  transform: translateY(-0.5rem);\n}\n\n.flex-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.flex-start {\n  align-items: flex-start;\n}\n\n.half {\n  width: 50%;\n  background-color: var(--white);\n}\n\n.one-third {\n  width: 33.33%;\n  background-color: var(--white);\n  padding: 1rem;\n}\n\n.two-third {\n  width: 66.66%;\n  background-color: var(--white);\n  padding: 1rem;\n}\n\n.entry {\n  width: 500px;\n  padding: 1rem;\n  background-color: var(--white);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.entry label {\n  font-size: 14px;\n  width: 40%;\n}\n\n.input {\n  width: calc(100% - 1rem) !important;\n  margin: 1rem;\n  margin-left: 1rem;\n}\n\n.label {\n  margin-left: 1rem;\n}\n\n.login-modal {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n}\n\n.modal-title {\n  margin-bottom: 1rem;\n}\n\n.register-link {\n  display: inline-block;\n  margin-top: 0.5rem;\n}\n\n.login-wrapper {\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.formItem {\n  margin-bottom: 1.5rem;\n}\n\n.ant-form-item-explain-error {\n  margin-bottom: 1rem;\n}\n\n.error {\n  color: #ef5350;\n}\n\nheader p,\nheader div p {\n  color: #777;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
